import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DiscountsService } from '../services/discounts.service';

export const discountsResolver = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const discountsService = inject(DiscountsService);
  let page = 1;

  if (route.queryParams['page']) {
    page = route.queryParams['page'];
  }

  return discountsService.getAll$(page).pipe(
    map(list => list),
    catchError(error => {
      router.navigate(['/dashboard']);
      return of({ list: null, error: error });
    })
  );
};
